import api from '@/common/api.js'

export default {
  namespaced: true,

  state: {
    total: 0,
    filters: {
      executada: 0
    },
    filtersFiltro: {
      executada: 0
    },
    items: [],
    details: {},
    pagination: {
      currentPage: 1,
      perPage: 12
    },
    mediaLiberacao: null,
    mediaLiberacaoArmazem: null,
    mediaLiberacaoReaberta: null,
    notaMecanico: null,
    totalReabertas: 0,
    empresas: '',
    segmentos: [],
    filesUpload: '',
    socorroRota: null,
    osEncerradas: null,
    checkSaveFilter: false,
    aberta_por: '',
    getJustificativa: null,
    empilhadeirasBloqueadas: null,
    empilhadeiraKey: ''
  },

  getters: {
    all: (state) => state,
    page: (state) => (page) => state.items[page],
    total: (state) => state.total,
    details: (state) => state.details,
    filters: (state) => state.filters,
    filtersFiltro: (state) => state.filtersFiltro,
    pagination: (state) => state.pagination,
    mediaLiberacao: (state) => state.mediaLiberacao,
    mediaLiberacaoArmazem: (state) => state.mediaLiberacaoArmazem,
    mediaLiberacaoReaberta: (state) => state.mediaLiberacaoReaberta,
    notaMecanico: (state) => state.notaMecanico,
    totalReabertas: (state) => state.totalReabertas,
    getEmpresas: (state) => state.empresas,
    getSegmentos: (state) => state.segmentos,
    getSocorroRota: (state) => state.socorroRota,
    getOsEncerradas: (state) => state.osEncerradas,

    getCheckSaveFilter: (state) => state.checkSaveFilter,
    aberta_por: (state) => {
      return state.aberta_por
    },
    getJustificativa: (state) =>
      (state.getJustificativa && state.getJustificativa.justificativaPause) || [],
    empilhadeiras: (state) => state.empilhadeirasBloqueadas
  },

  actions: {
    async getOsEncerrada({ commit }, { data }){
      try {
        const response = await api.get('os/getOsEncerrada', { params: data })

        commit('setOsEncerradas', response.data)
        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async sinalizarSinistro({ commit }, { data }) {
      try {
        const response = await api.post('os/informarSinstro', { ...data })

        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async getSocorroRota({ commit }) {
      try {
       const response = await api.get('os/getSocorroRota')
       
       commit('setSocorroRota', response.data)
       return response
      } catch (error) {
        throw Error(error)
      }
    },
    async getEmpresas({ commit }) {
      try {
        const params = {
          mostrar_em: 3
        }

        const response = await api.get('/getEmpresas', { params })

        commit('setEmpresas', response.data)
        return response
      } catch (error) {
        throw Error(error)
      }
    },

    async uploadFiles({ commit, state }, { data, nrSeqOs }){
      try{
        const response = await api.post(`os/uploadFiles/${nrSeqOs}`, data)

        return response
      } catch (error){
        throw Error(error)
      }
    },
    async finalizarOrcamento({ commit, state }, { data }){
      try{
        const response = await api.post(`os/finalizarOrcamento`, data)

        return response
      } catch (error){
        throw Error(error)
      }
    },
    async uploadFilesOrcamento({ commit, state }, { data, nrSeqOs }){
      try{
        const response = await api.post(`os/uploadFilesOrcamento/${nrSeqOs}`, data)

        return response
      } catch (error){
        throw Error(error)
      }
    },
    async uploadFilesOrdemServico({ commit, state }, { data, nrSeqOs }){
      try{
        const response = await api.post(`os/uploadFilesOrdemServico/${nrSeqOs}`, data)

        return response
      } catch (error){
        throw Error(error)
      }
    },
    async getImg({ commit, state}, { idOs }){
      try{
        const response = await api.get('os/getImages')

      } catch (error) {
        console.log(error)
        throw Error(error)
      }
    },
    async fetchFromApi ({ commit, state } ) {
      const pagination = {
        per_page: state.pagination.perPage,
        page: state.pagination.currentPage
      }

      try {
        commit('setData', { pageNumber: pagination.page, data: 'loading' })
        const params = {
          ...pagination,
          ...state.filters,
          status: ['A', 'R'],
          origem: 'I',
          liberado: false,
          ordernation: 'ASC'
        }

        const response = await api.get('os', { params: params })

        commit('setData', { pageNumber: response.data.current_page, data: response.data, total: response.data.total })
        return response
      } catch (error) {
        commit('setData', { pageNumber: pagination.page, data: [] })
        throw new Error(error)
      }
    },

    async fetchFromApiPreventivaArmazem ({ commit, state } ) {
      const pagination = {
        per_page: state.pagination.perPage,
        page: state.pagination.currentPage
      }

      try {
        commit('setData', { pageNumber: pagination.page, data: 'loading' })
        const params = {
          ...pagination,
          ...state.filters,
          status: 'A',
          origem: 'I',
          liberado: false,
          ordernation: 'ASC'
        }

        const response = await api.get('os/preventivaArmazem', { params: params })

        commit('setData', { pageNumber: response.data.current_page, data: response.data, total: response.data.total })
        return response
      } catch (error) {
        commit('setData', { pageNumber: pagination.page, data: [] })
        throw new Error(error)
      }
    },

    async fetchFromApiArmazem ({ state, commit }) {
      const pagination = {
        per_page: state.pagination.perPage,
        page: state.pagination.currentPage
      }


      try {
        commit('setData', { pageNumber: pagination.page, data: 'loading' })
        const params = {
          ...pagination,
          ...state.filters,
          status: 'A',
          origem: 'I',
          liberado: false,
          ordernation: 'ASC',
        }

        const response = await api.get('os/getArmazem', { params: params })

        commit('setData', { pageNumber: response.data.current_page, data: response.data, total: response.data.total })
        return response
      } catch (error) {
        commit('setData', { pageNumber: pagination.page, data: [] })
        throw new Error(error)
      }
    },

    async fetchFromApiArmazemExterna ({ state, commit  }) {
      const pagination = {
        per_page: state.pagination.perPage,
        page: state.pagination.currentPage
      }

      try {
        const filial = JSON.parse(localStorage.filial)

        commit('setData', { pageNumber: pagination.page, data: 'loading' })

        const params = {
          ...pagination,
          ...state.filters,
          status: 'A',
          origem: 'E',
          liberado: false,
          ordernation: 'ASC',
          filialEmpresa: filial.nr_sequencial
        }

        if(filial.fornecExt === 'S') {
          params.fornecExt = filial.tecnicoId
        }


        const response = await api.get('os/getArmazem', { params: params })

        commit('setData', { pageNumber: response.data.current_page, data: response.data, total: response.data.total })
        return response
      } catch (error) {
        commit('setData', { pageNumber: pagination.page, data: [] })
        throw new Error(error)
      }
    },

    async fetchFromApiPaleteiras ({ commit, state }) {
      const pagination = {
        per_page: state.pagination.perPage,
        page: state.pagination.currentPage
      }

      try {
        commit('setData', { pageNumber: pagination.page, data: 'loading' })
        const params = {
          ...pagination,
          ...state.filters,
          status: 'A',
          origem: 'I',
          liberado: false,
          ordernation: 'ASC',
          tipoVeiculo: 'paleteiras'
        }

        const response = await api.get('os/getArmazem', { params: params })

        commit('setData', { pageNumber: response.data.current_page, data: response.data, total: response.data.total })
        return response
      } catch (error) {
        commit('setData', { pageNumber: pagination.page, data: [] })
        throw new Error(error)
      }
    },
    
    async fetchFromApiExterna ({ commit, state } ) {
      const pagination = {
        per_page: state.pagination.perPage,
        page: state.pagination.currentPage
      }

      try {
        commit('setData', { pageNumber: pagination.page, data: 'loading' })

        const filial = JSON.parse(localStorage.filial)

        const params = {
          ...pagination,
          ...state.filters,
          status: 'A',
          origem: 'E',
          liberado: false,
          ordernation: 'ASC',
          filialEmpresa: filial.nr_sequencial
        }

        if(filial.fornecExt === 'S') {
          params.fornecExt = filial.tecnicoId
        }

        const response = await api.get('os/getExternas', { params: params })

        commit('setData', { pageNumber: response.data.current_page, data: response.data, total: response.data.total })
        return response
      } catch (error) {
        commit('setData', { pageNumber: pagination.page, data: [] })
        throw new Error(error)
      }
    },

    async getNotaMecanico({ commit }, { tecnicoId }){
      try {
        const response = api.get(`os/getNotaMecanico/${tecnicoId}`)

        response.then(response => {
          commit('setNotaMecanico', response.data[0].nota)
        })
        // commit('setNotaMecanico', response.data[0].nota)

        return response
      } catch (error) {
        throw new Error(error)
      }
    },



    async getSegmentos({ commit }) {
      try {
        const response = await api.get(`os/getSegmentos`)
        
        console.log(response.data)
        commit('setSegmentos', response.data.data)
        return response
      } catch (error) {
        return error
      }
    },

    async pesquisarSegmento({ commit }, { data }) {
      try {
        const response = await api.get(`os/pesquisarSegmento/${data}`)
        
        return response
      } catch (error) {
        return error
      }
    },

    async salvarSegmento({ commit }, { data }) {
      try {
        const response = api.post(`os/salvarSegmento`, { ...data })
        
        return response
      } catch (error) {
        return error
      }
    },

    async fetchFromApiReabertas ({ commit, state } ) {
      const pagination = {
        per_page: state.pagination.perPage,
        page: state.pagination.currentPage
      }

      try {
        commit('setData', { pageNumber: pagination.page, data: 'loading' })

        const filial = JSON.parse(localStorage.filial)

        const params = {
          ...pagination,
          ...state.filters,
          status: 'A',
          origem: 'I',
          liberado: false,
          ordernation: 'ASC',
          filialEmpresa: filial.nr_sequencial
        }

        if(filial.fornecExt === 'S') {
          params.fornecExt = filial.tecnicoId
        }

        const response = await api.get('os/getReabertas', { params: params })

        commit('setData', { pageNumber: response.data.current_page, data: response.data, total: response.data.total })
        commit('setTotalReabertas', response.data.total)
        return response
      } catch (error) {
        commit('setData', { pageNumber: pagination.page, data: [] })
        throw new Error(error)
      }
    },
    async osExterna({ commit, state }, { data }){
      try {
        const response = await api.post(`os/osExterna`, { ...data })

        return response
      } catch (error) {
        console.log(error)
        throw new Error(error)
      }
    },
    async integracaoTicket({ commit, state }){
      try {
        const response = await api.get(`os/integracaoTicket`)

        return response
      } catch (error) {
        console.log(error)
        throw new Error(error)
      }
    },
    async fetchMediaLiberacao ({ commit, state }, { filters, st_origem }) {
      try {
        commit('setMediaLiberacao', null)

        const filial = JSON.parse(localStorage.filial)

        if(filial.fornecExt === 'S') {
          filters = { ...filters, fornecExt: filial.tecnicoId }
        }
        const response = await api.get(`os/media-liberacao/${st_origem}`, { params: filters })

        commit('setMediaLiberacao', response.data)
        return response
      } catch (error) {
        commit('setMediaLiberacao', [])
        throw new Error(error)
      }
    },

    async testarPraxio ({ commit }) {
      try {
        const response = await api.get(`os/itens/execucoes/testePraxio`)
        return response
      } catch (error) {
        throw new Error(error)
      }
    },
    async fetchMediaLiberacaoArmazem ({ commit, state }, { filters, st_origem }) {
      try {
        commit('setMediaLiberacaoArmazem', null)
        const response = await api.get(`os/media-liberacao-armazem/${st_origem}`, { params: filters })

        commit('setMediaLiberacaoArmazem', response.data)
        return response
      } catch (error) {
        commit('setMediaLiberacaoArmazem', [])
        throw new Error(error)
      }
    },
    async fetchMediaLiberacaoReaberta ({ commit, state }, { filters, st_origem }) {
      try {
        commit('setMediaLiberacaoReaberta', null)
        const response = await api.get(`os/media-liberacao-reaberta/${st_origem}`, { params: filters })

        commit('setMediaLiberacaoReaberta', response.data)
        return response
      } catch (error) {
        commit('setMediaLiberacaoReaberta', [])
        throw new Error(error)
      }
    },
    async getDetails ({ commit }, { nrSequencial }) {
      commit('setDetails', 'loading')

      const filial = JSON.parse(localStorage.filial)
      
      const data = {
        nr_sequencial: nrSequencial,
        filial: filial.nr_sequencial
      }

      try {
        const response = await api.get(`os/${nrSequencial}`, { ...data })
        
        commit('setDetails', { os: response.data })
        return response
      } catch (error) {
        commit('setDetails', {})
        throw new Error(error)
      }
    },
    async updateObservacao ({ commit }, { id, data }) {
      try {
        const response = await api.put(`os/${id}/observacao`, data)

        commit('setDetails', { os: response.data.updated })
        return response
      } catch (error) {
        throw new Error(error)
      }
    },
    async resetFilial({ commit }, { newFilial }){
      try{
        const response = await api.post('os/newFilial', {newFilial: newFilial.nr_sequencial})

        return response
      } catch (error){
        throw new Error(error)
      }
    },
    async liberarVeiculo ({ commit }, { id, data }) {
      try {
        const response = await api.put(`os/${id}/liberar-veiculo`, data)

        commit('setDetails', { os: response.data.updated })
        return response
      } catch (error) {
        throw new Error(error)
      }
    },
    reset ({ commit }) {
      commit('reset')
    },

    async refreshNavs(){
      // this.$store.dispatch('osItemExecucao/fetchInternasFromApi')
      // this.$store.dispatch('osItemExecucao/fetchExternasFromApi')
      const filters = {
          placa: '',
          tipo: 'V',
          de: '',
          ate: '',
          codigo: ''
        }
      
      // this.$store.commit('osItemExecucao/setFilters', { filters: filters })
      this.$store.dispatch('osItemExecucao/fetchPreventivasFromApi')
    },
    async enviaOsExterna({ commit }, { data }){
      try{
        const response = api.put('os/getFornecedores/enviarOs', { ...data })

      } catch (error){
        throw Error(error)
      }
    },

    async getAbertoPor ({ state, commit }) {
      try {
        const response = await api.get(`os/getAbertoPor`, { params: state.filtersFiltro })

        commit('setAbertaPor', response.data.abertoPor)
      } catch (error) {
        throw new Error(error)
      }
    },

    async fetchFromGetJustificativa ({ commit }, { data }) {
      try {
        const response = await api.post(`os/get-justificativasWeb`, { ...data })

        commit('setJustificativas', response.data) 
        return response
      } catch (error) {
        throw new Error(error)
      }
    },

    async fetchFromApiEmpilhadeiraBloqueada({ commit }, params) {
      try {
        const response = await api.get('empilhadeiras/emps-bloq', { params })
        commit('setEmpilhadeiras', response.data.items)
        commit('setEmpilhadeiraKey', response.data.key)
      } catch (error) {
        console.error('Erro ao buscar empilhadeiras:', error)
        commit('setEmpilhadeiras', [])
      }
    }
  },

  mutations: {
    setSegmentos(state, segmentos) {
      state.segmentos = segmentos
    },
    setNotaMecanico(state, nota){
      state.notaMecanico = nota
    },
    setData (state, { pageNumber, data, total }) {
      if (total) {
        state.total = total
      }

      state.items[pageNumber] = data

      state.items = [
        ...state.items
      ]
    },
    setDetails (state, { os }) {
      state.details = os
    },
    reset (state) {
      state.total = 0
      state.items = []
    },
    setFilters (state, { filters }) {
      state.filters = {
        ...filters
      }
    },
    setFiltersFiltro (state, { filters }) {
      state.filtersFiltro = {
        ...filters
      }
    },
    setCurrentPage (state, { page }) {
      state.pagination.currentPage = page
    },
    setPerPage (state, perPage) {
      state.pagination.perPage = perPage
    },
    setMediaLiberacao (state, data) {
      state.mediaLiberacao = data
    },
    setMediaLiberacaoArmazem (state, data) {
      state.mediaLiberacaoArmazem = data
    },
    setMediaLiberacaoReaberta (state, data) {
      state.mediaLiberacaoReaberta = data
    },
    setTotalReabertas (state, total){
      state.totalReabertas = total
    },
    setEmpresas (state, empresas){
      state.empresas = empresas
    },

    setFilesUpload(state, files) {
      state.filesUpload = files
    },

    setSocorroRota(state, os){
      state.socorroRota = os
    },

    setOsEncerradas(state, os) {
      state.osEncerradas = os
    },

    setCheckSaveFilter(state, check){
      state.checkSaveFilter = check
    },

    setAbertaPor(state, aberta_por) {
      state.aberta_por = aberta_por
    },

    setJustificativas (state, getJustificativa) {
      state.getJustificativa = getJustificativa
    },

    setEmpilhadeiras(state, payload) {
      state.empilhadeirasBloqueadas = payload
    },

    setEmpilhadeiraKey(state, key) {
      state.empilhadeiraKey = key
    }
  }
}
